var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStartSelling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.94,5.34l-12.5,2.26c-.24-.26-.49-.52-.74-.77C7.75,2.9,4.76,3.09,3.41,4.46c-.66,.66-.99,1.51-.96,2.45,.07,2.02,1.79,4.48,5.25,7.5l.14-.16-1.46,10.19,21.72,21.12,18.57-19.1L24.94,5.34ZM4.45,6.84c-.01-.39,.11-.7,.38-.97,.74-.74,2.76-.21,5.24,2.17l-1.37,.25-.55,3.84c-3.13-2.92-3.67-4.55-3.7-5.28ZM28.04,41.32L9.57,23.36l1.79-12.51,1.03-.19c1.55,2.14,1.92,3.73,1.62,4.03l1.42,1.41c1.26-1.27,.6-3.54-.88-5.83l9.42-1.71,18.47,17.96-14.39,14.8Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.92,29.14c.09-.12,.18-.24,.25-.37,.89-1.52,1-3.22,.31-4.66-1.71-3.56-5.55-2.14-7.85-1.29-.51,.19-1,.37-1.4,.48-1.29,.36-2.14,.23-2.53-.39-.41-.67-.37-1.68,.1-2.36,.73-1.06,2.12-1.56,3.25-1.16l.77-2.2c-1.43-.5-3.02-.25-4.32,.54l-1.51-1.51-1.65,1.65,1.48,1.48c-.92,1.43-.97,3.38-.09,4.79,.56,.91,1.98,2.3,5.14,1.41,.49-.14,1.02-.33,1.58-.54,2.87-1.06,4.26-1.3,4.94,.11,.48,1.01,.07,1.99-.22,2.48-.61,1.05-1.74,1.8-2.79,1.87-.56,.04-1.1-.12-1.58-.45l-1.32,1.91c.9,.62,1.98,.93,3.05,.86,.96-.06,1.91-.42,2.75-.99l1.48,1.48,1.65-1.65-1.49-1.49Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartSelling);
export default __webpack_public_path__ + "static/media/icon_start_selling.c6c145cb16b17f4227491feb97132f44.svg";
export { ForwardRef as ReactComponent };